import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { ExpandButtonComponent } from './expandButtonComponent';

export class HamburgerButtonComponent extends ExpandButtonComponent {
  protected expandButtonSelector = '[data-js-hamburger-button]';
  private static hamburgerButtonComponentInstance: HamburgerButtonComponent;
  private static pageHeaderSelector = '[data-js-page-header]';
  private static opaqueClass = '-opaque';

  public static get instance(): HamburgerButtonComponent {
    if (!HamburgerButtonComponent.hamburgerButtonComponentInstance) {
      HamburgerButtonComponent.hamburgerButtonComponentInstance = new HamburgerButtonComponent();
    }

    return HamburgerButtonComponent.hamburgerButtonComponentInstance;
  }

  private static get pageHeader(): HTMLElement {
    return document.querySelector(HamburgerButtonComponent.pageHeaderSelector) || null;
  }

  protected onAnimateInStart(pageMenu: HTMLElement): void {
    const { pageHeader, opaqueClass } = HamburgerButtonComponent;

    disableBodyScroll(pageMenu, { reserveScrollBarGap: true });
    pageHeader.classList.add(opaqueClass);

    super.onAnimateInStart(pageMenu);
  }

  protected onAnimateOutStart(pageMenu: HTMLElement): void {
    const { pageHeader, opaqueClass } = HamburgerButtonComponent;

    pageHeader.classList.remove(opaqueClass);

    super.onAnimateOutStart(pageMenu);
  }

  protected onAnimateOutEnd(pageMenu: HTMLElement): void {
    enableBodyScroll(pageMenu);

    super.onAnimateOutEnd(pageMenu);
  }

  protected constructor() {
    super();
  }
}
